import './Navbar.scss';
import NavItem from './NavItem';
import { useState } from 'react';

// Icons
import right from '../assets/logo/right.svg';
import myPatients from '../assets/logo/patient.svg';
import cpLogo from '../assets/logo/cp.svg';
import history from '../assets/logo/history.svg';
import account from '../assets/logo/account.svg';
import billing from '../assets/logo/billing.svg';
import calendarIcon from '../assets/logo/calendar.svg';
import billingActive from '../assets/logo/billing-active.svg';
import calendar from '../assets/icons/calendar-inactive.png';
import calendarActive from '../assets/icons/calendar-active.png';
import patients from '../assets/icons/patients-inactive.png';
import patientsActive from '../assets/icons/patients-active.png';
import dashboardIcon from '../assets/logo/dashboard.svg';
import defDashboardIcon from '../assets/logo/dashboard-inactive.svg';
import notification from '../assets/logo/notification.svg';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import patientsSvg from '../assets/logo/patient.svg';
import PatientIcon from './Icons/patients';
import BillingIcon from './Icons/billing';
import DashboardIcon from './Icons/dashboard';

const Navbar = () => {
  const [toggleProfile, setToggleProfile] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const logOut = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div className="navbar-root">
      <div className="navbar-container">
        <div onClick={() => navigate('/dashboard')}>
          <img src={cpLogo} alt="cp-logo" />
        </div>

        <div className="navbar-nav-items">
          <NavItem
            to="/dashboard"
            text="Dashboard"
            icon={<DashboardIcon />}
            isActive={true}
          />

          <NavItem
            to="/dashboard/billing"
            text="Billing"
            icon={<BillingIcon />}
          />
          {/* temporarily removing until we have calendar integrated */}
          {/* <NavItem
            hoveredIcon={calendarActive}
            to="/dashboard/calendar"
            text="Calendar"
            icon={calendar}
          /> */}
          <NavItem
            to="/dashboard/patients"
            text="Patients"
            icon={<PatientIcon fillColor={'#b17f34'} />}
          />
        </div>

        <div className="navbar-notification">
          <img
            src={notification}
            alt="notification"
            className="notification-icon"
          />
          <div>
            <div className="navbar-profile-toggle">
              <small>{`${user.firstName} ${user.lastName}`}</small>
              <img
                src={right}
                alt="right"
                onClick={() => setToggleProfile(!toggleProfile)}
              />
            </div>
            {toggleProfile && (
              <div className="navbar-profile">
                <div className="navbar-profile-container">
                  <Link className="profile" to={'/dashboard/account'}>
                    Profile
                  </Link>
                  <hr className="separator" />
                  <h6 className="profile" onClick={logOut}>
                    Logout
                  </h6>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
